export type ChangeEventPayload = {
  value: string
}

type FaceMeasurements = {
  faceWidth: string
  farPD: {
    leftPD: string
    pd: string
    rightPD: string
  }
  nearPD: {
    leftPD: string
    pd: string
    rightPD: string
  }
  segmentHeight: {
    leftSH: string
    rightSH: string
  }
}

export type FaceData = {
  faceMeasurements: FaceMeasurements
  faceShape: string
}

export type ResultEventPayload = {
  faceData: string
  button: string
  raw?: {
    left: number
    right: number
  }
}

export type MeasurementResult = {
  faceData: FaceData
  button: string
  raw?: {
    left: number
    right: number
  }
}

export interface BrillenSdkModuleType {
  showView: (
    type: BrillenSdkViewType,
    locale: BrillenSdkViewLocale,
    translations: string
  ) => Promise<void>
  prepare: () => void
}

// FIXME: duplicated and modified from BrillenSdkModuleType. not sure how to pass frame.vbox to BrillenSDK
export interface SdkPlaceholderType {
  showView: (
    type: BrillenSdkViewType,
    locale: BrillenSdkViewLocale
  ) => Promise<void>
  prepare: () => void
}

const BrillenSdkLocales = ['en', 'de', 'pl', 'it', 'es'] as const

export type BrillenSdkViewLocale = (typeof BrillenSdkLocales)[number]
export type BrillenSdkViewType = 'pd' | 'sh'

export const isSdkLocale = (locale: string): locale is BrillenSdkViewLocale =>
  BrillenSdkLocales.includes(locale as BrillenSdkViewLocale)

export const SdkButtons = {
  save: 'Button-Save.1',
  close: 'CloseBtn',
} as const
